import $ from 'jquery';
import wheel from 'jquery-mousewheel';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import {Lethargy} from 'lethargy';

//wheel($);

class MainSlider {
    constructor($mainSlider) {
        this.animSpeed = 60;

        this.$win = $(window);
        this.$body = $('body');
        this.$wrap = $mainSlider;
        this.$slides = this.$wrap.find('.main-slider-slide');
        this.lock = false;
        this.winHeight = this.$win.innerHeight();
        this.scrollPos = this.$win.scrollTop();

        this.$active = this.$slides.filter('.main-slider-slide--active:last');
        this.initSlider();

        this.events();
    }

    events() {
        let lethargy = new Lethargy();

        this.$body.on('font-size-change', this.loadImages.bind(this));

        /* mouse events */
        this.$wrap.on('mousewheel', throttle(e => {
            if (this.isActive && lethargy.check(e) !== false) {
                if (e.deltaY < 0) this.nextSlide();
                else if (e.deltaY > 0) this.prevSlide();
            }
        }, 30));

        /* touch events */
        this.$win.on('touchstart', this.touchmove.bind(this));

        /* prevent iOS bounce scroll when going up */
        this.$body.on('touchstart', (event) => {
            let el = document.scrollingElement || document.documentElement;

            this.allowUp = (el.scrollTop > 0);
            this.allowDown = (el.scrollTop < el.scrollHeight - el.clientHeight);
            this.slideBeginY = event.targetTouches[0].pageY; //event.pageY

            // console.log('start', el.scrollTop, el.scrollHeight - el.clientHeight);
        });

        this.$body[0].addEventListener('touchmove', (event) => {
            let up = (event.targetTouches[0].pageY > this.slideBeginY),
                down = (event.targetTouches[0].pageY < this.slideBeginY);

            // console.log(event.targetTouches[0].pageY , this.slideBeginY);
            this.slideBeginY = event.targetTouches[0].pageY;
            if ((up && this.allowUp) || (down && this.allowDown)) {
                event.stopPropagation();
            } else {
                event.preventDefault();
            }
        }, {passive: false});

        /*this.$body.on('touchmove', function(event) {
         let up = (event.targetTouches[0].pageY > this.slideBeginY),
         down = (event.targetTouches[0].pageY < this.slideBeginY);

         this.slideBeginY = event.targetTouches[0].pageY;
         if ((up && this.allowUp) || (down && this.allowDown)) {
         event.stopPropagation();
         } else {
         event.preventDefault();
         }
         });*/

        /* arrow click */
        this.$wrap.find('.main-slider-indicator').on('click', e => {
            this.nextSlide();

            e.preventDefault();
        });

        /* keyboard events */
        this.$body.on('keydown', throttle(e => {
            let dir = 0;

            if ($.inArray(e.which, [40, 32, 34]) >= 0) dir = -1; // arrow down, space, page down
            else if ($.inArray(e.which, [38, 33]) >= 0) dir = 1; // arrow up, page up
            // home
            // end

            if (this.isActive) {
                if (dir > 0) {
                    this.prevSlide();
                } else if (dir < 0) {
                    this.nextSlide();
                }
            } else {
                this.toggleSlider({deltaY: dir});
            }
        }, 30));

        // this.$win.on('scroll', debounce(this.toggleSlider.bind(this), 30));
        // this.$win.on('scroll', debounce(() => { this.$body.toggleClass('on-top', this.$win.scrollTop() === 0); }, 30));
        this.$body.on('mousewheel', debounce(this.toggleSlider.bind(this), 30));
    }

    initSlider() {
        this.loadImages();

        // ostatni slajd jest sztuczny, przedostatni jest ostatnim prawdziwym
        // this.$slides.last().prev().addClass('main-slider-slide--last');

        // this.$body.toggleClass('is-first-slide-active', this.$active.is(':first-child'));

        if (this.$win.scrollTop() <= 0) {
            this.isActive = true;
            this.$body.addClass('main-slider-active non-scrollable');
        } else {
            this.isActive = false;
            this.$slides.addClass('main-slider-slide--active');
        }
    }

    touchmove(e) {
        let $target = $(e.target),
            swipe = e.originalEvent.touches,
            start = swipe[0].pageY;

        $target.on('touchmove', throttle(ev => {
                let contact = ev.originalEvent.touches,
                    end = contact[0].pageY,
                    distance = end - start;

                if (Math.abs(distance) > 30) {
                    if (this.isActive) {
                        if (distance < -30) this.nextSlide();
                        if (distance > 30) this.prevSlide();
                    } else {
                        this.toggleSlider({deltaY: distance});
                    }
                }
            }, 30))
            .one('touchend', () => {
                $target.off('touchmove touchend');
            });
    }

    loadImages() {
        this.$slides.find('[data-background-image]:visible').each((id, el) => {
            let $el = $(el),
                img = $el.data('background-image');

            /*Modernizr.on('webp', function(result) {
             if (result) {
             img = img.substr(0, img.lastIndexOf(".")) + '.webp';
             }
             $el.css('background-image', `url('${img}')`);
             });*/
            $el.css('background-image', `url('${img}')`)
                .removeAttr('data-background-image');
        });
    }

    switchSlide() {
        this.lock = true;

        setTimeout(() => {
            this.lock = false;
        }, 12 * this.animSpeed);
    }

    nextSlide() {
        if (!this.lock) {
            let $current = this.$wrap.find('.main-slider-slide--active:last'),
                $next = $current.next('.main-slider-slide');

            if ($next.length) {
                this.switchSlide();

                $current.removeClass('main-slider-slide--current');
                $next.addClass('main-slider-slide--active main-slider-slide--current');

                this.$active = $next;

                setTimeout(() => {
                    let el = $next.find('.main-slider-content')[0];
                    el.style.display = 'none'; el.offsetHeight; el.style.display = 'block';
                }, 100);

                // this.$body.removeClass('is-first-slide-active');
                this.toggleSliderColor();
            } else if (!this.deactivating) {
                this.deactivateAndSkip();
                this.toggleSliderColor(7 * this.animSpeed);
            }
        }
    }

    prevSlide() {
        if (this.$active.is(':first-child')) {
            // this.$body.addClass('is-first-slide-active');
            return;
        }

        if (!this.lock) {
            this.switchSlide();
            this.$active
                .removeClass('main-slider-slide--active main-slider-slide--current')
                .addClass('main-slider-slide--released');

            this.$active = this.$wrap.find('.main-slider-slide--active:last')
                .addClass('main-slider-slide--current');
            this.toggleSliderColor(0);

            setTimeout(() => {
                this.$wrap.find('.main-slider-slide--released').removeClass('main-slider-slide--released');
            }, 10 * this.animSpeed);
        }
    }

    toggleSliderColor(timeout) {
        setTimeout(() => {
            this.$body.toggleClass('inverted', this.isActive && this.$active.hasClass('dark'));
            setTimeout(() => {
                $('.lang-menu a').fancyHover('redraw');
            }, 250);
        }, timeout);
    }

    toggleSlider(e) {
        // this.$body.toggleClass('on-top', this.$win.scrollTop() === 0);
        if (!this.deactivating && !this.isActive && this.$win.scrollTop() <= 0 && e.deltaY > 0) {
            this.activateAndSkip();
        }
    }

    /*toggleSlider() {
     if (!this.deactivating && !this.$body.hasClass('main-slider-active')) {
     let oldPos = this.scrollPos;
     this.scrollPos = this.$win.scrollTop();

     if (this.scrollPos < oldPos) {
     // this.$body.toggleClass('main-slider-active', this.$win.scrollTop() <= 0);
     if (!this.activating && this.scrollPos <= 0) {
     this.activateAndSkip();
     }
     } else {
     if (this.scrollPos >= this.winHeight) {
     this.$body.removeClass('inverted');
     }
     }
     }
     }*/

    activateAndSkip() {
        this.switchSlide();
        this.$body.addClass('main-slider-active non-scrollable on-top');
        this.$body.find('.top-bar').addClass('top');
        this.toggleSliderColor(0);
        this.isActive = true;
    }

    deactivateAndSkip() {
        this.deactivating = true;
        this.isActive = false;

        this.$body.removeClass('main-slider-active on-top');

        setTimeout(() => {
            this.$body.removeClass('non-scrollable');
            this.deactivating = false;
        }, 10 * this.animSpeed);
    }
}

export default MainSlider;



// WEBPACK FOOTER //
// ./sources/js/components/main-slider.js